import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "I",
    title: "Ideia",
    tech: "Escuta · Referências",
    body:
      "Tudo começa com uma conversa. Você compartilha a memória, o gesto, a pessoa, o momento — e a gente escuta com atenção pra entender o que dá vida à peça.",
    img: "https://images.unsplash.com/photo-1519741497674-611481863552?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwYm91cXVldHxlbnwwfHx8fDE3ODQ4NTEyODR8MA&ixlib=rb-4.1.0&q=85",
    meta: "Etapa I / III",
  },
  {
    n: "II",
    title: "Criação",
    tech: "Modelagem 3D · Aprovação",
    body:
      "Transformamos sua história em desenho e depois em modelo 3D. Você acompanha cada versão, ajusta o que quiser — e só seguimos quando você diz sim.",
    img: "https://images.unsplash.com/photo-1642969164999-979483e21601?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHwzZCUyMHByaW50ZXIlMjBtYWNybyUyMHRlY2hub2xvZ3l8ZW58MHx8fHwxNzg0ODUxMjg0fDA&ixlib=rb-4.1.0&q=85",
    meta: "Etapa II / III",
  },
  {
    n: "III",
    title: "Entrega",
    tech: "Impressão · Acabamento",
    body:
      "A peça é impressa em detalhe milimétrico, finalizada à mão e embalada com carinho. Chega até você pronta pra emocionar quem for receber.",
    img: "https://images.pexels.com/photos/32167663/pexels-photo-32167663.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=800",
    meta: "Etapa III / III",
  },
];

export default function ChapterProcesso() {
  return (
    <section
      id="processo"
      className="relative py-32 md:py-48 bg-[var(--bg-2)]"
      data-testid="chapter-processo"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="flex items-center gap-6 mb-14 md:mb-20">
            <span className="font-mono-tech text-[11px] text-[var(--accent)]">
              Capítulo 02
            </span>
            <span className="w-24 h-px bg-[var(--line-2)]" />
            <span className="font-mono-tech text-[11px] text-[var(--ink-2)]">
              Como acontece
            </span>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <h2 className="font-serif-display text-5xl md:text-7xl lg:text-8xl tracking-[-0.03em] leading-[0.95] max-w-[18ch] mb-20 md:mb-32">
            Da sua história{" "}
            <span className="italic text-[var(--ink-2)]">até suas mãos.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <article className="group flex flex-col">
                <div className="border-t border-[var(--line-2)] pt-6 flex items-baseline justify-between">
                  <span className="font-serif-display text-4xl md:text-5xl italic text-[var(--accent)] leading-none">
                    {s.n}
                  </span>
                  <span className="font-mono-tech text-[10px] text-[var(--ink-3)]">
                    {s.meta}
                  </span>
                </div>

                <div className="mt-6 aspect-[4/5] overflow-hidden spotlight">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="w-full h-full object-cover"
                  />
                </div>

                <div className="mt-6 flex items-baseline justify-between">
                  <h3 className="font-serif-display text-3xl md:text-4xl tracking-tight leading-none">
                    {s.title}
                  </h3>
                  <span className="font-mono-tech text-[10px] text-[var(--ink-3)]">
                    {s.tech}
                  </span>
                </div>

                <p className="mt-4 font-sans text-[14px] leading-[1.7] text-[var(--ink-2)] max-w-[36ch]">
                  {s.body}
                </p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
